import { usePDFStore } from '../../stores/pdf.store'
import { PDFViewerPagesIndicators } from '../PDFViewer'
import { FieldSettingsPanel } from './FieldSettingsPanel'

export const SidebarPanel = () => {
  const currentEditingField = usePDFStore(
    (state) => state.currentEditingFieldId
  )

  if (currentEditingField) return <FieldSettingsPanel />

  return <PDFViewerPagesIndicators />
}
